import { Layout } from "@Components/Layout";
import InterestFreePaymentOptions from "@Components/Pages/Pre-Footer/Interest-Free-Payment-Options";

const InterestFreePaymentOptionsPage = () => {
  return (
    <Layout>
      <InterestFreePaymentOptions />
    </Layout>
  );
};
export default InterestFreePaymentOptionsPage;
